export const regExpUpperCaseLetters = /^[A-Z]/;
export const regExpNumbersAndLetters = /[^A-Za-z0-9 ]/g;
export const regExpLetters = /[^A-Za-z ]/g;
export const regExpLettersAndUnderscore = /^[A-Za-z][A-Za-z_]*$/;
export const regExpLettersNumbersUnderscoreHyphen = /^[A-Za-z][A-Za-z0-9_-]*$/;
export const regExpNumbers = /[^0-9]/g;
export const regExpOnlyNumbers = /^\d+$/;
export const regExpNumbersWithDots = /^\d+(\.\d+)*$/;
export const regExpDecimal = /[^0-9.]/g;
export const regExpDecimalOnlyTenths = /^\d*\.?\d?$/;
export const regExpDecimalOnlyThousandths = /^\d*\.?\d{0,3}$/;
export const regExpDecimalAndHyphen = /[^0-9.-]/g;
export const regExpWithoutSpace = /\s/g;
export const regExpTelecomId = /^[a-zA-Z0-9_-]*$/;
export const regExpNumeric = /\B(?=(\d{3})+(?!\d))/g;
export const regExpCoord = /^(-)?\d+(.\d+)?$/;
export const regExpKaiApiToken = /[^A-Za-z0-9._:\- ]/g;
export const regExpSchemaNameImport = /^[a-zA-Z0-9_.:-]+$/;
export const regExpLettersNumbersSpacesCommonPunctuation = /^[A-Za-z0-9 ,.!?-]+$/;
